import React from 'react';
import AppShell from '../../components/app-shell/app-shell';  
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import HowToTakeAClass from "../../components/landing-pages/how-to-take-a-class";
import markdown from './how-to-take-a-class.md';

export default function() {
  return (
    <AppShell
      seoTitle="How to Take a Class"
      description="Know what to expect from an online calligraphy class with Calligraphy.org"
    >
      <PublicShell>
        <HowToTakeAClass />
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
